import equineLeftSideImage from '../../ImageDiagnosis/diagnosisImages/assets/equine-leftside.png';
import equineRightSideImage from '../../ImageDiagnosis/diagnosisImages/assets/equine-rightside.png';
import { DxImageWithPointsAndConditions } from '../imageDxTypes';
import {
  orthopedicOa,
  orthopedicOther,
  navicular,
  tendinopathy,
  neurological,
  sacroiliacDisease,
  odsp
} from '../painConditions';

// canineDxImages is the list of image (right and left sides) with all points for the dog pain diagnosis.
export const equinePainDxImages: DxImageWithPointsAndConditions[] = [
  {
    name: 'Right Side',
    imageUrl: equineRightSideImage,
    points: [
      {
        label: 'Right Hind Fetlock',
        name: 'right_hind_fetlock',
        x: 63,
        y: 379,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Right Hind Pastern',
        name: 'right_hind_pastern',
        x: 94,
        y: 407,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Right Hind Coffin',
        name: 'right_hind_coffin',
        x: 88,
        y: 436,
        conditions: [orthopedicOa, orthopedicOther, navicular, tendinopathy]
      },
      {
        label: 'Right Fore Fetlock',
        name: 'right_fore_fetlock',
        x: 554,
        y: 374,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Right Fore Pastern',
        name: 'right_fore_pastern',
        x: 576,
        y: 407,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Right Fore Coffin',
        name: 'right_fore_coffin',
        x: 582,
        y: 442,
        conditions: [orthopedicOa, orthopedicOther, navicular, tendinopathy]
      },
      {
        label: 'Right Carpus',
        name: 'right_carpus',
        x: 430,
        y: 383,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Right Elbow',
        name: 'right_elbow',
        x: 405,
        y: 290,
        conditions: [orthopedicOa, orthopedicOther]
      },
      {
        label: 'Right Shoulder',
        name: 'right_shoulder',
        x: 460,
        y: 240,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Sacral',
        name: 'sacral',
        x: 265,
        y: 160,
        conditions: [orthopedicOa, orthopedicOther, neurological]
      },
      {
        label: 'Lumbar',
        name: 'lumbar',
        x: 325,
        y: 165,
        conditions: [orthopedicOa, orthopedicOther, neurological, odsp]
      },
      {
        label: 'Thoracic',
        name: 'thoracic',
        x: 390,
        y: 160,
        conditions: [orthopedicOa, orthopedicOther, neurological, odsp]
      },
      {
        label: 'Cervical',
        name: 'cervical',
        x: 460,
        y: 168,
        conditions: [orthopedicOa, orthopedicOther, neurological]
      },
      {
        label: 'Right Sacroiliac',
        name: 'right_sacroiliac',
        x: 290,
        y: 195,
        conditions: [orthopedicOa, orthopedicOther, sacroiliacDisease]
      },
      {
        label: 'Right Hip',
        name: 'right_hip',
        x: 225,
        y: 221,
        conditions: [orthopedicOa, orthopedicOther]
      },
      {
        label: 'Right Stifle',
        name: 'right_stifle',
        x: 240,
        y: 286,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Right Hock',
        name: 'right_hock',
        x: 205,
        y: 366,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      }
    ]
  },
  {
    name: 'Left Side',
    imageUrl: equineLeftSideImage,
    points: [
      {
        label: 'Left Hind Fetlock',
        name: 'left_hind_fetlock',
        x: 603,
        y: 379,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Hind Pastern',
        name: 'left_hind_pastern',
        x: 572,
        y: 407,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Hind Coffin',
        name: 'left_hind_coffin',
        x: 578,
        y: 436,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Fore Fetlock',
        name: 'left_fore_fetlock',
        x: 112,
        y: 374,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Fore Pastern',
        name: 'left_fore_pastern',
        x: 99,
        y: 407,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Fore Coffin',
        name: 'left_fore_coffin',
        x: 84,
        y: 442,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Carpus',
        name: 'left_carpus',
        x: 236,
        y: 383,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Elbow',
        name: 'left_elbow',
        x: 261,
        y: 290,
        conditions: [orthopedicOa, orthopedicOther]
      },
      {
        label: 'Left Shoulder',
        name: 'left_shoulder',
        x: 206,
        y: 240,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Cervical',
        name: 'cervical',
        x: 220,
        y: 168,
        conditions: [orthopedicOa, orthopedicOther, neurological]
      },
      {
        label: 'Lumbar',
        name: 'lumbar',
        x: 341,
        y: 165,
        conditions: [orthopedicOa, orthopedicOther, neurological, odsp]
      },
      {
        label: 'Thoracic',
        name: 'thoracic',
        x: 276,
        y: 160,
        conditions: [orthopedicOa, orthopedicOther, neurological, odsp]
      },
      {
        label: 'Sacral',
        name: 'sacral',
        x: 396,
        y: 160,
        conditions: [orthopedicOa, orthopedicOther, neurological]
      },
      {
        label: 'Left Sacroiliac',
        name: 'left_sacroiliac',
        x: 376,
        y: 195,
        conditions: [orthopedicOa, orthopedicOther, sacroiliacDisease]
      },
      {
        label: 'Left Hip',
        name: 'left_hip',
        x: 441,
        y: 221,
        conditions: [orthopedicOa, orthopedicOther]
      },
      {
        label: 'Left Stifle',
        name: 'left_stifle',
        x: 426,
        y: 286,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      },
      {
        label: 'Left Hock',
        name: 'left_hock',
        x: 461,
        y: 366,
        conditions: [orthopedicOa, orthopedicOther, tendinopathy]
      }
    ]
  }
];
